<template>
    <div class="overview" v-if="date !== null">
        <div class="page-header">
            <h1>
                Available rooms&nbsp;

                <small>
                    {{date | moment("MMMM \'YY")}}
                </small>

                <div class="clearfix visible-xs"></div>

                <div class="pull-right">
                    <date-picker v-model="date" :config="{format: 'MMMM YYYY'}"></date-picker>
                </div>

                <div class="pull-right">
                    <print></print>&nbsp;
                </div>

                <div class="clearfix visible-xs"></div>
            </h1>
        </div>

        <available-rooms v-for="n in days" :key="n" :date="dayOfMonth(n)" v-if="types.length" :types="types"></available-rooms>
    </div>
</template>

<style lang="scss" scoped>
    .overview {
        .room {
        }

        .controls {
            > * {
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import Print from '@/components/layout/Print'

    const moment = require('moment')

    import DatePicker from 'vue-bootstrap-datetimepicker'
    import AvailableRooms from '@/components/rooms/AvailableRooms'

    const TypeService = require('@/services/rooms/TypeService')

    export default {
        data() {
            return {
                date: null,
                types: []
            }
        },

        computed: {
            days() {
                return this.date.daysInMonth()
            }
        },

        mounted() {
            this.setDefaultDate()
            this.loadTypes()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            dayOfMonth(offset) {
                offset--;

                const date = moment(this.date)
                date.startOf('month')

                date.add(offset, 'days')

                return date
            },

            loadTypes() {
                TypeService.findAll({
                    sort: [{
                        key: 'title',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.types = data.rows
                })
            }
        },

        components: {
            DatePicker,
            Print,
            AvailableRooms
        }
    }
</script>


// WEBPACK FOOTER //
// Available.vue?28c3ed16